import React, { useState } from 'react'
import GeneralFormInput from '../../forms/GeneralFormInput'
import {useStripe, useElements, PaymentElement, CardElement} from '@stripe/react-stripe-js';
import { getData, postData } from '../../../ApiCalls/DataApis';
import toast from 'react-hot-toast';
import { apiLink } from '../../../ApiCalls/ApisVariables';


function AddCardSetupForm({isDark, closeModal, updateOrganizationsList}) {
    const [form, setForm] = useState({
        orgName: '',
        orgDescription: '',
      })
    const [loading, setLoading] = useState(false)
    const stripe = useStripe();
    const elements = useElements();
    const [termsConditions, setTermsConditions] = useState(false)
    const [errorMessage, setErrorMessage] = useState(null);


    const CARD_ELEMENT_OPTIONS = {
        style: {
          base: {
            color: isDark ? '#d1d5db':"#32325d",
            border:isDark ? '1px solid #d1d5db':"1px solid #32325d",
            fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
            fontSmoothing: "antialiased",
            fontSize: "16px",
            "::placeholder": {
              color: "#aab7c4",
    
            },
          },
          invalid: {
            color: "#fa755a",
            iconColor: "#fa755a",
          },
        },
      };


  // **** Functions for General Input forms **** 
  const handleGeneralFormChange = (event) => {
    // Get the name of the field that caused this change event
    // Get the new value of this field
    const { name, value } = event.target;

    // Assign new value to the appropriate form field
    const updatedForm = {
      ...form,
      [name]: value
    };

    // console.log('Form changed: ', updatedForm);

    // Update state
    setForm(updatedForm);

  }
  // **** Functions for Input Department ****


//   const submitAddNewOrg = () => {
//     try {
//       if(!loading){
//         setLoading(true)
//         postData(apiLink + '/v1/organizations/free-trial', 
//         {'organization_name': form.orgName,
//         'organization_description': form.orgDescription,
//         'is_free_trial_bundle': true,
//         'organization_is_private': true,})
//         .then(async response => {
//           const data = await response.json();
//           if(response.ok){
//             setLoading(false)
//             closeModal()
//             toast.success('Organization created')
//             updateOrganizationsList()
            
//           }
//           else{
//             try{
//               const data = await response.json();
//               toast.error(data.message)
//               setLoading(false)
//             }catch (e){
//               setLoading(false)
//               console.log('error')
//             }
//           }
//         }) 
//       }
//     } catch (error) {
//       console.log(error.message)
//     }

//   }

  const handleSubmit = async (event) => {
    
    
    // // We don't want to let default form submission happen here,
    // // which would refresh the page.
    event.preventDefault();
    var cardElement = elements.getElement('card');
    
    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make  sure to disable form submission until Stripe.js has loaded.
      return;
    }

    if (!loading) {
        setLoading(true)
        getData(apiLink + '/v1/payment_methods/setup_intent')
        .then(async response => {
          if(response.ok ){
            const data = await response.json();
            const result = await stripe.confirmCardSetup(data.client_secret, {
              payment_method: {
                card: elements.getElement(CardElement),
              }
            });
            if (result.error) {
              
              toast.error(result.error.message);
              cardElement.clear();
              setLoading(false)
              // Display result.error.message in your UI.
            } else {
              toast.success('Card verified, sending to database');
              // The setup has succeeded. Display a success message and send
              // result.setupIntent.payment_method to your server to save the
              // card to a Customer
              console.log('form.organizationName', form.orgName)
              console.log('form.organizationDescription', form.orgDescription)
              postData(apiLink + '/v1/organizations', 
              {'organization_name': form.orgName,
                'organization_description': form.orgDescription,
                'organization_is_private': true,
                'payment_method': result.setupIntent.payment_method}) 
                .then(async response => {
                  const data = await response.json();
                  if(response.ok){
                    // Clear the Element:
                    cardElement.clear();
                    toast.success("New Organization has been successfully added!");
                    setLoading(false)
                    setForm({
                        orgName: '',
                        orgDescription: '',
                    })
                    closeModal()
                    
                  }
                  else{
                    try{
                        toast.error(data.message);
                        // Clear the Element:
                        cardElement.clear();
                        setLoading(false)
                        setForm({
                            orgName: '',
                            orgDescription: '',
                        })
                        closeModal()
                    }catch (e){
                      // Clear the Element:
                      cardElement.clear();
                      toast.error(e.message);
                    }
                  }
                })
            }
            
          }
        });
      }
  };


  return (
    <form onSubmit={handleSubmit}>
        <div className='px-4'>
            <div className="pt-4">
            <GeneralFormInput label='Organization Name' type='text' placeholder='' name='orgName' onChange={handleGeneralFormChange} />
            </div>
            <div className="py-4">
            <GeneralFormInput label='Organization Description' type='text' placeholder='' name='orgDescription' onChange={handleGeneralFormChange} />
            </div>
            <div className={`border-[1px] px-2 py-1 rounded ${isDark? 'border-slate-600':'border-slate-300'}`}>
                <CardElement options={CARD_ELEMENT_OPTIONS}/>
            </div>
            <div className="flex items-center mt-6">
                <input 
                    checked={termsConditions} 
                    id="checked-termsConditions" 
                    type="checkbox" 
                    onChange={(e) => setTermsConditions(e.target.checked)}
                    className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                />
                <label htmlFor="checked-termsConditions" className={`ml-2 text-sm font-medium ${isDark?'text-gray-400':'text-gray-600'}`}>
                    By clicking Submit, you have read and agree to the IoTFlows <a href='https://www.iotflows.com/policies/terms-of-use' target='_blank' className='text-blue-500'>Terms of Use</a> and <a href='https://www.iotflows.com/console/pricing' target='_blank' className='text-blue-500'>Pricing</a>
                </label>
            </div>
                <div className={`flex p-4 px-5 items-center mt-4 border-t-[0px] ${isDark?' border-gray-700':'border-gray-200'}`}>
                    <button
                    type="button"
                    className={`inline-flex rounded-md  bg-transparent border  ${isDark?' border-slate-600 text-gray-400 hover:bg-slate-600':'border-gray-100 text-gray-600 hover:bg-gray-100'} px-4 py-2 text-sm font-medium focus:outline-none focus-visible:ring-2 focus-visible:ring-gray-500 focus-visible:ring-offset-2`}
                    onClick={closeModal}
                    >
                    Cancel
                    </button>
                    <button 
                        className={`relative cursor-pointer ml-auto inline-flex rounded-md border border-transparent ${isDark?' text-blue-100 bg-blue-900 hover:bg-blue-800 disabled:bg-blue-700':'text-blue-900 bg-blue-100 hover:bg-blue-200 disabled:bg-blue-100'} px-4 py-2 text-sm font-medium focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 disabled:opacity-50 disabled:cursor-default `}
                        disabled={form.orgName =='' || !stripe || !termsConditions || loading}
                        >
                        Submit
                        {loading && 
                            <div >
                                <svg aria-hidden="true" className={`absolute top-1/4 right-1/3 ml-8 w-5 h-15 animate-spin dark:fill-white dark:text-gray-500 fill-blue-600 text-gray-300`} viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"></path>
                                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"></path>
                                </svg>
                            </div>
                        }
                    </button>
                    </div>
            
            {/* Show error message to your customers */}
            {errorMessage && <div>{errorMessage}</div>}
        </div>
    </form>
  )
}

export default AddCardSetupForm